import React from 'react';
import {useGuideConfig} from '../../hooks';
import DemoPageContainer from './DemoPageContainer';
import GuidePageContainer from './GuidePageContainer';

const PageContainer = (props) => {
  const { isDemoMode } = useGuideConfig();
  return isDemoMode ? <DemoPageContainer {...props} /> : <GuidePageContainer {...props} />;
};

PageContainer.propTypes = {
  ...GuidePageContainer.propTypes
};

export default PageContainer;
